import { formPostApi, mutateApi, queryApi } from "src/utils/api/ApiMethods"
import { camelCaseToSnakeKeys } from "src/utils/object_helpers"
import { getCurrentMarinaSlug } from "src/utils/url/parsing/marina"

export const previewReceiptConfiguration = (data) => {
  const marinaSlug = getCurrentMarinaSlug()

  // Convert camelCase keys to snake_case to match backend expectations
  const snakeCaseData = camelCaseToSnakeKeys(data)

  // Build query string from converted data object
  const params = new URLSearchParams()
  Object.entries(snakeCaseData).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== "") {
      params.append(key, value)
    }
  })

  const queryString = params.toString()
  const url = `/manage/${marinaSlug}/settings/paper_receipts/preview${
    queryString ? `?${queryString}` : ""
  }`

  return queryApi(url)
}

export const updateReceiptConfiguration = (data) => {
  const marinaSlug = getCurrentMarinaSlug()
  const url = `/manage/${marinaSlug}/settings/paper_receipts`

  // Convert camelCase keys to snake_case to match backend expectations
  const snakeCaseData = camelCaseToSnakeKeys(data)

  return mutateApi({
    url,
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    data: { receipt_configuration: snakeCaseData },
  })
}

export const uploadReceiptLogo = (file) => {
  const marinaSlug = getCurrentMarinaSlug()
  const url = `/manage/${marinaSlug}/settings/paper_receipts/upload_logo`

  const formData = new FormData()
  formData.append("file", file)

  return formPostApi({
    url,
    data: formData,
  })
}

export const removeReceiptLogo = () => {
  const marinaSlug = getCurrentMarinaSlug()
  const url = `/manage/${marinaSlug}/settings/paper_receipts/remove_logo`

  return mutateApi({
    url,
    method: "DELETE",
  })
}
